/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';



import 'swiper/css/bundle';
import 'glightbox/dist/css/glightbox.min.css'

import AboutSection from './AboutSection';
import ServicesSection from './ServiceSection';
import PortfolioSection from './PortfolioSection';
import JournalSection from './JournalSection';
import ContactSection from './ContactSection';
import Header from './Header';
import MainHeader from './MainHeader';
import Footer from './Footer';


function HomePage() {


  return (
    <div>
      <Header />
      <MainHeader />
      <AboutSection />
      <ServicesSection />
      <PortfolioSection />
      <JournalSection />
      <ContactSection />
      <Footer />
        <a href="#" class="back-to-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>     
    </div>
  );
};

export default HomePage;
